import { render, staticRenderFns } from "./DetailErrorsDialog.vue?vue&type=template&id=d8c5e71c&scoped=true&"
import script from "./DetailErrorsDialog.vue?vue&type=script&lang=js&"
export * from "./DetailErrorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c5e71c",
  null
  
)

export default component.exports